import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { RichTextEditorComponent } from 'shared/feature-rich-text-editor';
import { FormFieldComponent, IconDirective, InputDirective, LabelDirective , ButtonDirective } from 'shared/ui-common';

@Component({
  standalone: true,
  imports: [
    MatDialogModule,
    FormsModule,
    MatButtonModule,
    TranslocoModule,

    InputDirective,
    LabelDirective,
    MatInputModule,
    FormFieldComponent,
    MatIconModule,
    IconDirective,
    RichTextEditorComponent,
    ButtonDirective,
  ],
  selector: 'tt-medication-edit-dialog',
  templateUrl: './medication-edit-dialog.component.html',
  styleUrls: ['./medication-edit-dialog.component.scss'],
  host: { class: 'tt-medication-edit-dialog' },
})
export class MedicationEditDialogComponent implements OnInit {
  protected dialogRef = inject<MatDialogRef<MedicationEditDialogComponent>>(MatDialogRef);

  protected data = inject<{
    title: string;
    name: string;
    description: string;
  }>(MAT_DIALOG_DATA);

  protected title = signal('');
  protected description = signal('');

  public ngOnInit(): void {
    this.title.set(this.data.title ? this.data.title : '');
    this.description.set(this.data.description ? this.stripHtmlTags(this.data.description) : '');
  }

  protected saveEditedData(): void {
    this.dialogRef.close({ title: this.title(), description: this.description() });
  }

  protected stripHtmlTags(input: string): string {
    return input.replace(/<[^>]*>/g, '');
  }
}
